import { setGlobalOptions } from '../loader-utils/option-utils';
export function setLoaderOptions(options) {
  setGlobalOptions(options);
}
//# sourceMappingURL=set-loader-options.js.map


// WEBPACK FOOTER //
// ./~/@loaders.gl/core/dist/esm/lib/api/set-loader-options.js